import { router, Slot, useGlobalSearchParams } from "expo-router";
import { useTranslation } from "react-i18next";
import { View } from "tamagui";

import { api } from "~/utils/api";
import { ResearchBreadcrumbs } from "~/components/feature/research";
import type { Slices } from "~/components/feature/research";

const Layout = () => {
  const { type } = useGlobalSearchParams<{
    type: Slices;
  }>();

  const { t } = useTranslation("research");

  const [slice] = api.research.types.useSuspenseQuery(undefined, {
    select: (data) => data.find((item) => item.value === type),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  return (
    <View gap={"$3"}>
      <ResearchBreadcrumbs
        list={[
          slice,
          {
            name: t("create-research-funnel.layout.breadcrumbs-page-title"),
            value: "createResearch",
          },
        ]}
        active={"createResearch"}
        onPress={(value) => {
          if (value !== "createResearch") {
            router.push(`/research/${value}`);
          }
        }}
      />
      <Slot />
    </View>
  );
};

export default Layout;
